import * as types from './time-tracking.types';
import * as constants from './time-tracking.constants';

export const initialTimeTrackingPage = (): types.IInitialTimeTrackingPage => ({
  type: constants.INITIAL_TIME_TRACKING_PAGE,
});
